const mixin = {
  data () {
    return {};
  },
  methods: {
    showError (error, isSignInError, isUserError, callback, customText, options = {}) {
      if (error) {
        let errorList = '';
        if (error.response && error.response.data.errors) {
          errorList = Object.entries(error.response.data.errors).map((err) => {
            return `${options.isAdmin ? `${err[0]}: ` : ''}${this.$t(err[1][0])}`;
          }).join(', ');
        } else if (error.message) {
          errorList = error.message;
        }
        if (!callback) {
          if (isSignInError) {
            this.$swal.fire({ title: this.$t('errorTitleSigIn'), text: errorList });
          } else if (isUserError) {
            this.$swal.fire({ title: this.$t('ErrorHasOccurred'), text: errorList });
          } else if (customText) {
            this.$swal.fire({ text: customText });
          } else {
            this.$swal.fire({ text: errorList });
          }
        } else {
          this.$swal.fire({ text: errorList }).then(() => callback());
        }
      }
    }
  },
  mounted () {}
};

export default mixin;
